import { render } from "./deals-transaction.vue?vue&type=template&id=8535a76c"
import script from "./deals-transaction.vue?vue&type=script&lang=js"
export * from "./deals-transaction.vue?vue&type=script&lang=js"

import "./deals-transaction.vue?vue&type=style&index=0&id=8535a76c&lang=css"

import exportComponent from "D:\\MY PROJECTS\\VUE_3\\EXCEL_LIBRARY\\excel-library-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__